<template>
  <div :class="`a-loading-secondary ${loadingClass}`">
    <img
      alt="loading"
      src="@/assets/loading/loading-animation.gif"
    />
  </div>
</template>

<script>
export default {
  name: 'AtomLoadingSecondary',

  props: {
    loadingClass: {
      type: String,
      default: ''
    }
  }
}
</script>
